import axios from "axios";
import { getAuthHeader } from "../../utils/authHeader";
import type { DashboardMetrics, PaginatedRenewals } from "./types";

export async function getDashboardMetrics(): Promise<DashboardMetrics> {
    try {
        const headers = await getAuthHeader();

        const response = await axios.get<DashboardMetrics>(
            `${process.env.REACT_APP_BACKEND_URL}/campaign-renewal/metrics`,
            { headers }
        );

        return response.data;
    } catch (error) {
        console.error("Error fetching dashboard metrics:", error);
        throw new Error("Error fetching dashboard metrics");
    }
}

export async function getPaginatedRenewals(
    page = 1,
    limit = 20,
    search = "",
    status = "All",
    sortBy?: string,
    sortDirection?: "asc" | "desc"
): Promise<PaginatedRenewals> {
    try {
        const headers = await getAuthHeader();

        const params: any = { page, limit, search, status };
        if (sortBy) {
            params.sortBy = sortBy;
            params.sortDirection = sortDirection || "asc";
        }

        const response = await axios.get<PaginatedRenewals>(
            `${process.env.REACT_APP_BACKEND_URL}/campaign-renewal/renewals`,
            {
                params,
                headers,
            }
        );

        return response.data;
    } catch (error) {
        console.error("Error fetching paginated renewals:", error);
        throw new Error("Error fetching renewals");
    }
}

export async function getStaleCampaigns(
    page = 1,
    limit = 20,
    search = "",
    sortBy?: string,
    sortDirection?: "asc" | "desc"
): Promise<PaginatedRenewals> {
    try {
        const headers = await getAuthHeader();

        const params: any = { page, limit, search };
        if (sortBy) {
            params.sortBy = sortBy;
            params.sortDirection = sortDirection || "asc";
        }

        const response = await axios.get<PaginatedRenewals>(
            `${process.env.REACT_APP_BACKEND_URL}/campaign-renewal/stale-campaigns`,
            {
                params,
                headers,
            }
        );

        return response.data;
    } catch (error) {
        console.error("Error fetching stale campaigns:", error);
        throw new Error("Error fetching stale campaigns");
    }
}

export async function scheduleRenewal(campaignId: string): Promise<void> {
    try {
        const headers = await getAuthHeader();

        const response = await axios.post(
            `${process.env.REACT_APP_BACKEND_URL}/campaign-renewal/schedule-renewal`,
            { campaignId },
            { headers }
        );

        if (response.status !== 200) {
            throw new Error("Failed to schedule renewal");
        }
    } catch (error) {
        console.error("Error scheduling renewal:", error);
        throw new Error("Error scheduling renewal");
    }
}

export async function cancelRenewal(
    campaignId: string,
    reason?: string
): Promise<void> {
    try {
        const headers = await getAuthHeader();

        const response = await axios.post(
            `${process.env.REACT_APP_BACKEND_URL}/campaign-renewal/cancel-renewal`,
            { campaignId, reason },
            { headers }
        );

        if (response.status !== 200) {
            throw new Error("Failed to cancel renewal");
        }
    } catch (error) {
        console.error("Error canceling renewal:", error);
        throw new Error("Error canceling renewal");
    }
}

export async function getRenewalDetails(renewalId: string): Promise<any> {
    try {
        const headers = await getAuthHeader();

        const response = await axios.get(
            `${process.env.REACT_APP_BACKEND_URL}/campaign-renewal/renewal-details/${renewalId}`,
            { headers }
        );

        return response.data;
    } catch (error) {
        console.error("Error fetching renewal details:", error);
        throw new Error("Error fetching renewal details");
    }
}